import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import { track } from "../../lib/api";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("pageview");
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
